import { render, staticRenderFns } from "./PurchaseInfoContact.vue?vue&type=template&id=5ecb7bd4"
import script from "./PurchaseInfoContact.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecb7bd4')) {
      api.createRecord('5ecb7bd4', component.options)
    } else {
      api.reload('5ecb7bd4', component.options)
    }
    module.hot.accept("./PurchaseInfoContact.vue?vue&type=template&id=5ecb7bd4", function () {
      api.rerender('5ecb7bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoContact.vue"
export default component.exports